<template>
  <header class="editorial-nav-shell">
    <a class="skip-link" href="#main-content">Skip to content</a>
    <nav class="editorial-nav editorial-container" aria-label="Main navigation">
      <EditorialWordmark />
      <NavBarItems class="desktop-navigation" />
      <div class="desktop-auth"><AuthState /></div>
      <button
        class="mobile-menu-button"
        aria-label="Open navigation menu"
        aria-controls="mobile-navigation"
        :aria-expanded="menuOpen"
        data-testid="menu-toggle"
        :disabled="!isMounted"
        @click="$emit('open:menu')"
      >
        Menu
        <span aria-hidden="true">☰</span>
      </button>
    </nav>
  </header>
</template>
<script setup lang="ts">
const isMounted = useMounted()
defineProps<{ menuOpen?: boolean }>()
defineEmits(['open:menu'])
</script>
